function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", {
  type: "text/css"
}));

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M740.4032 297.6768H112.64a25.6 25.6 0 1 1 0-51.2h627.7632a25.6 25.6 0 0 1 0 51.2zM574.976 540.5184H48.896a25.6 25.6 0 1 1 0-51.2H574.976a25.6 25.6 0 1 1 0 51.2zM404.48 783.36H109.7216a25.6 25.6 0 0 1 0-51.2H404.48a25.6 25.6 0 0 1 0 51.2z",
  "p-id": 14863
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M384 1003.1616a25.6 25.6 0 0 1-7.7824-1.2288A511.2832 511.2832 0 1 1 974.4896 258.7648a25.6 25.6 0 1 1-44.288 25.6A460.0832 460.0832 0 1 0 391.8336 953.1392a25.6 25.6 0 0 1-7.8336 50.0224z",
  "p-id": 14864
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "M393.5232 901.7856a25.6 25.6 0 0 1-20.48-9.984c-80.6912-104.448-125.1328-238.336-125.1328-376.8832C248.1152 302.08 351.8464 107.52 518.8096 7.3216a25.6 25.6 0 0 1 26.368 0c94.0544 56.32 171.7248 146.8928 218.6752 254.464a25.6 25.6 0 0 1-46.9504 20.48C676.4032 189.44 611.072 110.8992 531.968 59.4432c-143.872 93.2864-232.6528 266.24-232.6528 455.68 0 127.2832 40.6528 250.0608 114.432 345.6a25.6 25.6 0 0 1-20.48 41.2672zM671.6928 896a25.6 25.6 0 0 1-15.7696-5.4784l-112.64-88.2688a25.6 25.6 0 0 1-4.352-35.84l318.6688-406.1696a25.6 25.6 0 0 1 17.0496-9.6256 26.0608 26.0608 0 0 1 18.8928 5.12l112.64 88.32a25.6 25.6 0 0 1 4.352 35.84l-318.6688 406.3744a25.6 25.6 0 0 1-17.1008 9.6256c-1.024 0.1024-2.048 0.1024-3.072 0.1024z m-76.8-118.272l72.4992 56.832 287.0272-365.8752-72.2432-56.6784z",
  "p-id": 14865
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  d: "M908.8 574.7712a25.6 25.6 0 0 1-15.7696-5.4784L791.9104 489.984a25.6 25.6 0 0 1 31.6416-40.2944l101.0688 79.3088a25.6 25.6 0 0 1-15.8208 45.7728zM483.0208 1020.7232a25.6 25.6 0 0 1-24.1152-34.2016l76.1856-212.9408a25.6 25.6 0 0 1 39.8848-11.52l112.64 88.2688a25.6 25.6 0 0 1-1.6896 41.5232l-188.8256 124.6208a25.088 25.088 0 0 1-14.08 4.2496zM571.3408 824.32l-38.3488 107.1616 94.976-62.72z",
  "p-id": 14866
});

function SvgMigrant(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    t: 1632295324736,
    className: "icon",
    viewBox: "0 0 1024 1024",
    xmlns: "http://www.w3.org/2000/svg",
    "p-id": 14862,
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 200,
    height: 200,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMigrant);
export default __webpack_public_path__ + "static/media/migrant.c08b9a97.svg";
export { ForwardRef as ReactComponent };